module.exports = __webpack_public_path__ + "20230117/img/slide2_ren.64a099e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide2_ren.png
// module id = 29eZ
// module chunks = 1